import React, { useState } from 'react';
import s from './CmsPLPBanner.module.css';

interface CmsButton {
  text: string;
  url: string;
  variant: string;
  inverted: boolean;
  icon: string;
  icon_position: string;
  external: boolean;
  _metadata: { uid: string };
}

interface CmsPLPBannerData {
  name?: string;
  body?: string;
  component?: string;
  media?: { url: string } | null;
  media_position?: string;
  buttons?: CmsButton[];
  _metadata?: { uid: string };
}

interface CmsPLPBannerProps {
  data?: CmsPLPBannerData;
}

export const CmsPLPBanner: React.FC<CmsPLPBannerProps> = ({ data }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen || !data) return null;

  const handleClose = () => setIsOpen(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" onClick={handleClose}>
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      <div
        className="relative w-[800px] h-[740px] bg-white rounded-[20px] p-[20px] flex flex-col items-center shadow-[2px_4px_4px_0_rgba(0,0,0,0.25)]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-[20px] right-[20px] text-[#22539F] text-[24px] font-bold leading-none cursor-pointer bg-transparent border-none p-0"
          onClick={handleClose}
          aria-label="Close"
        >
          ✕
        </button>

        {data.name && <h2 className={s.title}>{data.name}</h2>}

        {data.body && <div className={s.body} dangerouslySetInnerHTML={{ __html: data.body }} />}

        {data.buttons && data.buttons.length > 0 && (
          <div className="mt-[207px] flex gap-[16px]">
            {data.buttons.map((button) => (
              <button key={button._metadata?.uid} className={s.actionButton} onClick={handleClose}>
                {button.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CmsPLPBanner;
